import { render, staticRenderFns } from "./Vacations.vue?vue&type=template&id=2be0871d&"
import script from "./Vacations.vue?vue&type=script&lang=js&"
export * from "./Vacations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports